import axios from "axios";

export const ReactivateAccountRequest = (email: string, onSuccess: (message: string) => void, onFailure: (message: string) => void) => {
  return () => {
    axios
      .patch(`/visitor/activate-request?email=${email}`,)
      .then((response) => {
        if (response?.status === 200) {
          onSuccess(response?.data?.message)
        } else {
          onFailure(response?.data?.message)
        }
      })
      .catch((error) => {
        onFailure(error?.response?.data?.message)
      });
  };
};